import { render, staticRenderFns } from "./left-banner.vue?vue&type=template&id=27c477ec&scoped=true&"
import script from "./left-banner.vue?vue&type=script&lang=ts&"
export * from "./left-banner.vue?vue&type=script&lang=ts&"
import style0 from "./left-banner.vue?vue&type=style&index=0&id=27c477ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c477ec",
  null
  
)

export default component.exports